import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "show", "root", "popup", "size", "position", "onClose", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from '../Flowbite/ThemeContext';
import { ModalBody } from './ModalBody';
import { ModalContext } from './ModalContext';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
var ModalComponent = function ModalComponent(_ref) {
  var children = _ref.children,
    show = _ref.show,
    root = _ref.root,
    popup = _ref.popup,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '2xl' : _ref$size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'center' : _ref$position,
    onClose = _ref.onClose,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(root),
    _useState2 = _slicedToArray(_useState, 2),
    parent = _useState2[0],
    setParent = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    container = _useState4[0],
    setContainer = _useState4[1];
  var theme = useTheme().theme.modal;
  useEffect(function () {
    if (!parent) setParent(document.body);
    if (!container) setContainer(document.createElement('div'));
  }, []);
  useEffect(function () {
    if (!container || !parent || !show) {
      return;
    }
    parent.appendChild(container);
    return function () {
      if (container) {
        parent.removeChild(container);
      }
    };
  }, [container, parent, show]);
  return container ? createPortal(_jsx(ModalContext.Provider, {
    value: {
      popup: popup,
      onClose: onClose
    },
    children: _jsx("div", _objectSpread(_objectSpread({
      "aria-hidden": !show,
      className: classNames(theme.base, theme.positions[position], show ? theme.show.on : theme.show.off, className),
      "data-testid": "modal",
      role: "dialog"
    }, props), {}, {
      children: _jsx("div", {
        className: classNames(theme.content.base, theme.sizes[size]),
        children: _jsx("div", {
          className: theme.content.inner,
          children: children
        })
      })
    }))
  }), container) : null;
};
ModalComponent.displayName = 'Modal';
ModalHeader.displayName = 'Modal.Header';
ModalBody.displayName = 'Modal.Body';
ModalFooter.displayName = 'Modal.Footer';
export var Modal = Object.assign(ModalComponent, {
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter
});